module.exports = __webpack_public_path__ + "static/media/D-sharp-Triads.dcf02b37.png";